
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },

  data: () => ({
    title: "Les erreurs SEO les plus courantes et comment les éviter",
    description:
      "Découvrez les erreurs SEO qui pénalisent votre classement : choix des mots-clés, optimisation technique, netlinking et balises meta. ALEO vous aide à les corriger.",
  }),

  head() {
    return {
      title: this.title,
      meta: [
        {
          hid: "description",
          name: "description",
          content: this.description,
        },
        {
          hid: "og:title",
          property: "og:title",
          content: this.title,
        },
        {
          hid: "og:description",
          property: "og:description",
          content: this.description,
        },
      ],
    };
  },
};
